module.exports = __webpack_public_path__ + "img/fxzn.d21cf85d.svg";